import React from 'react';
import Container from '../container';
import RichtextParser from '../../utils/richtext-parser';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';

const OuterContainer = styled.div`
  background: #161616;
  padding: 104px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mq.mobile(css`
    padding: 48px 0px;
  `)};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -1.04px;
  @media (max-width: 876px) {
    font-size: 36px;
    letter-spacing: -0.5px;
  }
`;

const Description = styled.p`
  color: #c4c4c4;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  max-width: 716px;
`;

export default function BasicHero({
  title,
  description
}: {
  title: string;
  description: any;
}) {
  return (
    <OuterContainer>
      <Container>
        <ContentContainer>
          <Title>{title}</Title>
          <Description
            dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
          />
        </ContentContainer>
      </Container>
    </OuterContainer>
  );
}
